import { Form, Spinner } from "react-bootstrap";
import { getCategoryRouteSummary } from "../../Categories/utils/category.utils";

const CategorySelectList = ({
  categories = [],
  selectedIds = [],
  onChange,
  pricing = {},
  onPricingChange,
  pricingErrors = {},
  disabled = false,
  isLoading = false,
  isError = false,
}) => {
  if (isLoading) {
    return (
      <div className="d-flex align-items-center gap-2 text-muted">
        <Spinner animation="border" size="sm" />
        Loading categories...
      </div>
    );
  }

  if (isError) {
    return (
      <p className="text-danger mb-0">
        Failed to load categories. Please refresh and try again.
      </p>
    );
  }

  if (!categories.length) {
    return (
      <p className="text-muted mb-0">
        No categories found. Create a category with a route first.
      </p>
    );
  }

  return (
    <div className="d-flex flex-column gap-2">
      {categories.map((category) => {
        const id = category._id || category.id;
        const aliases = [id, category.id, category.key].filter(Boolean);
        const checked = selectedIds.some((value) => aliases.includes(value));
        const pricingError = pricingErrors[id] || pricingErrors[category.key];

        return (
          <div
            key={id}
            className="d-flex align-items-start gap-2 p-2 border rounded"
          >
            <Form.Check
              type="checkbox"
              id={`rally-category-${id}`}
              className="mt-1"
              checked={checked}
              disabled={disabled || !id}
              onChange={(e) => {
                const withoutAliases = selectedIds.filter(
                  (value) => !aliases.includes(value)
                );
                const next = e.target.checked
                  ? [...withoutAliases, id]
                  : withoutAliases;
                onChange(next);
              }}
            />
            <div className="flex-grow-1">
              <label
                htmlFor={`rally-category-${id}`}
                className="mb-0"
                style={{ cursor: disabled ? "default" : "pointer" }}
              >
                <div className="fw-semibold">
                  {category.title || category.key || "Untitled category"}
                </div>
                <div className="text-muted small">
                  {getCategoryRouteSummary(category)}
                </div>
              </label>

              {checked ? (
                <Form.Group className="mt-2 mb-0" style={{ maxWidth: 220 }}>
                  <Form.Label className="small mb-1">
                    Price <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    min="0"
                    step="0.01"
                    value={pricing[id] ?? ""}
                    onChange={(e) => onPricingChange?.(id, e.target.value)}
                    placeholder="Amount"
                    disabled={disabled}
                    isInvalid={!!pricingError}
                  />
                  <Form.Control.Feedback type="invalid">
                    {pricingError}
                  </Form.Control.Feedback>
                </Form.Group>
              ) : null}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CategorySelectList;
